import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TestcaseComponent } from './testcase/testcase.component';
import { TestsuiteComponent } from './testsuite/testsuite.component';
import { MastersuiteComponent } from './mastersuite/mastersuite.component';
import { NewExecutionHistoryComponent } from './new-execution-history/new-execution-history.component';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: 'testcase', component: NewExecutionHistoryComponent },
            { path: 'testsuite', component: NewExecutionHistoryComponent },
            { path: 'mastersuite', component: NewExecutionHistoryComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ExecutionHistoryRoutingModule { }
